import { client } from "api";
import { OrderSerial } from "models/OrderSerial";

export type CreateChecklistSerialRequest =
  // Required for creation
  { checklistId: string; rowNo: number } &
    // Optional for creation
    Partial<Pick<OrderSerial, "doa" | "parentId" | "description">> &
    // Exclude fields not needed for creation
    Omit<
      OrderSerial,
      | "id"
      | "orderNo"
      | "description"
      | "rowNo"
      | "item"
      | "installed"
      | "room"
      | "roomClassification"
      | "children"
      | "editable"
      | "doaDate"
    >;

export type CreateChecklistSerialResponse = OrderSerial;

export const createChecklistSerial = ({ checklistId, ...data }: CreateChecklistSerialRequest) =>
  client
    .post<CreateChecklistSerialResponse>(`/checklist/serial/create-new/${checklistId}`, data)
    .then((res) => res.data);
